// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2XIiP","buttons":"RemoveExpirationActionButtons_buttons__EWqxV"};